module.exports = __webpack_public_path__ + "img/Cookie_1_resize_01.cc5349f3.png";